import { render } from "./AbortTeaserCard.vue?vue&type=template&id=2b599786&scoped=true"
import script from "./AbortTeaserCard.vue?vue&type=script&lang=js"
export * from "./AbortTeaserCard.vue?vue&type=script&lang=js"

import _style_0 from "./AbortTeaserCard.vue?vue&type=style&index=0&id=2b599786&inline&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-2b599786"]])

export default __exports__